import React from "react";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import useMainSlider from "./useMainSlider";

export default function () {
  const {handleSubmit, setErrors, mainSliderFields} = useMainSlider();
  const navigate = useNavigate();

  const addSlider = data => {
    let formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    axios.post('main-sliders', formData).then(res => {
      navigate('/main-sliders');
    }).catch(err => {
      if (err.response) {
        setErrors(err.response.data?.errors || {});
      }
    });
  }

  return (
    <Card title="Add slider">
      <form className="form w-100" onSubmit={handleSubmit(addSlider)}>
        {mainSliderFields}

        <SubmitButton title="Add" classes='mt-5'/>
      </form>
    </Card>
  );
}